import { Nullable } from "~/types/general.types";

export const removeQueryParam = (
  slug?: Nullable<string | string[]>,
): string | undefined => {
  const returnedSlug = Array.isArray(slug) ? slug.join("/") : slug;
  return returnedSlug?.split("?")[0];
};
